import React from 'react';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="8"
      fill="none"
      viewBox="0 0 13 8"
    >
      <path
        fill="#000"
        d="M5.66 7.168c.11.164.274.219.465.219a.577.577 0 00.465-.219l5.305-5.305a.66.66 0 00.19-.465c0-.164-.081-.328-.19-.464l-.602-.602c-.137-.11-.3-.191-.465-.191-.191 0-.355.054-.465.164L6.125 4.543 1.887.305A.743.743 0 001.422.14a.66.66 0 00-.465.191L.355.934a.64.64 0 00-.19.464c0 .192.054.356.19.465L5.66 7.168z"
        opacity="0.64"
      />
    </svg>
  );
}

export default Icon;
